import styled from 'styled-components';

export const StyledDiv = styled.div`
  margin: 200px 0px 0px 0px;
`;
